import { Box, Grid, Text } from '@factorialco/deprecated-design-system'
import { ProcurementPurchaseOrdersLegalEntityFragment } from 'generated/resources/graphql'

import { countryName } from 'modules/core/lib/countryList'
import i18n from 'modules/core/lib/i18n'

import InfoItem from 'modules/procurement/components/InfoItem'

interface Props {
  legalEntity: ProcurementPurchaseOrdersLegalEntityFragment
}

const formatAddress = (legalEntity: ProcurementPurchaseOrdersLegalEntityFragment) => {
  const addressFormated = [
    legalEntity.addressLine1,
    legalEntity.addressLine2,
    legalEntity.postalCode,
    legalEntity.city,
    legalEntity.state,
  ]
    .filter(Boolean)
    .join(', ')

  return addressFormated.length > 0 ? addressFormated : '-'
}

const LegalEntityInfo = ({ legalEntity }: Props) => {
  const legalEntityInfo = [
    {
      label: i18n.t('procurement.purchase_orders.detail.legal_entity.legal_name'),
      value: legalEntity.legalName ?? '-',
    },
    {
      label: i18n.t('procurement.purchase_orders.detail.legal_entity.tin'),
      value: legalEntity.tin ?? '-',
    },

    {
      label: i18n.t('procurement.purchase_orders.detail.legal_entity.address'),
      value: formatAddress(legalEntity),
    },
    {
      label: i18n.t('procurement.purchase_orders.detail.legal_entity.country'),
      value: countryName(legalEntity.country) ?? '-',
    },
  ]

  return (
    <Box gap="s12">
      <Text weight="bold" size="200" color="grey800" caps>
        {i18n.t('procurement.purchase_orders.detail.legal_entity.title')}
      </Text>
      <Grid variant="fixed">
        {legalEntityInfo.map((item) => (
          <Box gridColSpan={{ xxs: 6 }} key={item.label}>
            <InfoItem label={item.label} textItem={item.value} />
          </Box>
        ))}
      </Grid>
    </Box>
  )
}

export default LegalEntityInfo
